export const __LoadingLang = {
    loading: 'درحال بارگذاری',
};
